import { AuditedEntity } from '../../audited-entity'

export class ControlCenter extends AuditedEntity {
  public id: string

  public facility: string
  public number: string
  public type: ControlCenterType

  public name: string
  public description: string

  public storage: ControlCenterStorage = new ControlCenterStorage()

  public workStations: string[] = []

  public labelPrinter: PrinterConfiguration
  public documentPrinter: PrinterConfiguration
}

export enum ControlCenterType {
  WORK_STATION = 'WORK_STATION',

  STORAGE = 'STORAGE',
}

export class ControlCenterStorage {
  public storageScope: string
}

export class PrinterConfiguration {
  public printerId: string
}
